/**
 * Parses a SAP-style JSON date string like "/Date(1548328944000+0000)/" into a Date object.
 *
 * @param raw The SAP-formatted date string or Date object
 * @returns A Date instance or undefined if input is invalid
 */
export function parseSapDate(raw: Date | string | null | undefined): Date | undefined {
  if (!raw) {
    return undefined;
  }

  if (raw instanceof Date) {
    return raw;
  }

  const sapDateRegex = /\/Date\((?<timestamp>\d+)(?:[+-]\d{4})?\)\//u;

  const match = sapDateRegex.exec(raw);

  if (!match?.groups?.timestamp) {
    console.warn('Invalid SAP date string:', raw);

    return undefined;
  }

  const timestamp = Number(match.groups.timestamp);

  if (Number.isNaN(timestamp)) {
    return undefined;
  }

  return new Date(timestamp);
}
